import { Loader2 } from 'lucide-react'
import { cn } from '@/utils/cn'
import { formFieldInputClass, formFieldLabelClass } from '@/components/shared/formFieldClasses'
import { useLeadSourceOptions } from '@/hooks/useLeadSourceOptions'

type Props = {
  label?: string
  value: string
  onChange: (value: string) => void
  className?: string
  selectClassName?: string
  placeholder?: string
  emptyLabel?: string
  showHint?: boolean
  error?: string
}

export function LeadSourceSelect({
  label = 'Origem',
  value,
  onChange,
  className,
  selectClassName,
  placeholder,
  emptyLabel = 'Selecione...',
  showHint = true,
  error,
}: Props) {
  const { options, loading, loadError, isEmpty } = useLeadSourceOptions()

  const selectPlaceholder = loading
    ? 'Carregando origens...'
    : isEmpty
      ? 'Nenhuma origem ativa cadastrada'
      : placeholder ?? emptyLabel

  const selectClass = cn(
    selectClassName ?? formFieldInputClass,
    'cursor-pointer disabled:cursor-not-allowed disabled:opacity-60',
    !selectClassName && 'min-h-[38px] px-3 py-2 text-[13px]',
    error && 'border-red-500/50 focus:border-red-500',
  )

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label ? (
        <label className={formFieldLabelClass} style={{ fontSize: 'var(--font-size-label)' }}>
          {label}
        </label>
      ) : null}
      <div className='relative'>
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={loading || isEmpty || loadError}
          className={selectClass}
        >
          <option value=''>{selectPlaceholder}</option>
          {options.map((name) => (
            <option key={name} value={name}>
              {name}
            </option>
          ))}
        </select>
        {loading && (
          <Loader2
            size={14}
            className='absolute right-3 top-1/2 -translate-y-1/2 animate-spin text-text-muted pointer-events-none'
          />
        )}
      </div>
      {showHint && !loading && (
        <span className='text-[10px] text-text-muted'>
          {loadError
            ? 'Não foi possível carregar origens. Verifique a API ou cadastre em Configuração → Origens.'
            : isEmpty
              ? 'Cadastre origens ativas em Configuração → Origens.'
              : 'Opções de Configuração → Origens (ativas).'}
        </span>
      )}
    </div>
  )
}
